/**
 * A simple Gateway Dialog
 */
export default class Gateway {
	constructor() {
		this.createEventHandlers();
	}
	//@ts-ignore
	//public buttonElementList: NodeListOf<Element> = document.getElementsByClassName('gatewayButton');

	/* Client now wants ALL external links to display gateway
	   -----------------------------------------------------
	   Hostname is undefined for map links like agent-services.html?state=MO, at least locally
	*/
	//@ts-ignore
	public buttonElementList = Array.from(document.querySelectorAll("a")).filter(l => l.hostname !== undefined && l.hostname !== location.hostname);
	public gatewayElement: HTMLElement = document.getElementById('gateway');
	public clickedElement: HTMLElement;

	// gateway Button methods
	private addModal(event: Event) {
		event.preventDefault();
		
		this.clickedElement = event.target as HTMLElement;
		this.gatewayElement.classList.add('show');
		const gatewayUrlElement = this.gatewayElement.querySelector('#gatewayUrl');
		const redirect = this.clickedElement.getAttribute('href') ? this.clickedElement.getAttribute('href') : this.clickedElement.closest('a[href]').getAttribute('href');

		// Client request
		const redirectText = redirect === 'https://alic.chsitech.com/login.aspx?Reason=NoUser&ReturnUrl=%2Fdefault.aspx' ? 'https://alic.chsitech.com/login.aspx' : redirect;

		gatewayUrlElement.textContent = redirectText;
		this.createModalEventHandlers(redirect);
	}
	private createEventHandlers() {
		for (var i = 0; i < this.buttonElementList.length; i++) {
			this.buttonElementList[i].addEventListener('click', this.addModal.bind(this));
		}
	}

	// gateway Modal methods
	private approve(redirect: string) {
		location.href = redirect;
	}
	private decline() {
		(this.gatewayElement).classList.remove('show');
	}
	private createModalEventHandlers(redirect: string) {
		const approveButton = (this.gatewayElement).querySelectorAll('button[data-action="approve"]');
		const declineButton = (this.gatewayElement).querySelectorAll('button[data-action="decline"]');

		for (var i = 0; i < approveButton.length; ++i) {
			approveButton[i].addEventListener('click', this.approve.bind(this, redirect));
		}
		for (var i = 0; i < declineButton.length; ++i) {
			declineButton[i].addEventListener('click', this.decline.bind(this));
		}
	}
}